module.exports = __webpack_public_path__ + "static/media/35.bbe5b9de.mp3";